import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import api from '../utils/api';
import toast from 'react-hot-toast';

export default function ResetPasswordPage() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password !== confirm) { toast.error('Las contraseñas no coinciden'); return; }
    if (password.length < 6) { toast.error('Mínimo 6 caracteres'); return; }
    setLoading(true);
    try {
      await api.post(`/auth/reset-password/${token}`, { password });
      toast.success('Contraseña actualizada');
      navigate('/login');
    } catch (err) { toast.error(err.response?.data?.error || 'Error al restablecer'); }
    finally { setLoading(false); }
  };

  return (
    <div style={{ minHeight: '100vh', background: '#0d0d0d', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }}>
      <div style={{ width: '100%', maxWidth: 400 }}>
        <div style={{ background: '#1a1a1a', borderRadius: 16, padding: 32, border: '1px solid #2d2d2d' }}>
          <h2 style={{ color: 'white', fontSize: 20, fontWeight: 600, marginBottom: 20 }}>Nueva contraseña</h2>
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label className="form-label" style={{ color: '#aaa' }}>Nueva contraseña</label>
              <input className="form-input" type="password" required style={{ background: '#2d2d2d', border: '1px solid #3d3d3d', color: 'white' }}
                value={password} onChange={e => setPassword(e.target.value)} placeholder="Mínimo 6 caracteres" />
            </div>
            <div className="form-group">
              <label className="form-label" style={{ color: '#aaa' }}>Confirmar contraseña</label>
              <input className="form-input" type="password" required style={{ background: '#2d2d2d', border: '1px solid #3d3d3d', color: 'white' }}
                value={confirm} onChange={e => setConfirm(e.target.value)} placeholder="Repite la contraseña" />
            </div>
            <button type="submit" className="btn btn-primary" style={{ width: '100%', justifyContent: 'center' }} disabled={loading}>
              {loading ? <><span className="spinner"/>Actualizando...</> : 'Actualizar contraseña'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
